import React, { useEffect, useState } from 'react';

import useMartyContext from 'hooks/useMartyContext';
import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';
import { loadFromLocalStorage, saveToLocalStorage } from 'helpers/localStorageUtilities';

import css from 'styles/components/common/toggleButton.scss';

export interface ToggleButtonProps {
  label: string;
  infoCopy: string;
  handleToggle: (isToggled: boolean) => void;
  isToggledDefault: boolean;
  storageKey: string;
  id: string;
}

const ToggleButton = (props: ToggleButtonProps) => {
  const { label, infoCopy, handleToggle, isToggledDefault, storageKey, id } = props;
  const localStorageList = loadFromLocalStorage(storageKey, {});
  const defaultValue = storageKey && localStorageList ? localStorageList[storageKey] : isToggledDefault;
  const [isToggled, setIsToggled] = useState(defaultValue);

  const { testId } = useMartyContext();

  useEffect(() => {
    if (storageKey) {
      const localStorageList = loadFromLocalStorage(storageKey, {});

      if (Object.keys(localStorageList).length > 0) {
        setIsToggled(localStorageList[storageKey]);
      } else {
        setIsToggled(isToggledDefault);
        updateLSToggle(isToggledDefault);
      }
    } else {
      setIsToggled(isToggledDefault);
    }
  }, [isToggledDefault]);

  const onToggle = () => {
    setIsToggled(!isToggled);
    handleToggle?.(!isToggled);
    updateLSToggle(!isToggled);
  };

  const updateLSToggle = (lsIsToggled: boolean) => {
    if (storageKey) {
      const localStorageList = loadFromLocalStorage(storageKey, {});
      localStorageList[storageKey] = lsIsToggled;
      saveToLocalStorage(storageKey, localStorageList);
    }
  };

  return (
    <div className={css.toggleContainer}>
      {label && (
        <label data-test-id={testId(`${id}Label`)} className={css.toggleLabel} htmlFor="toggleBtn">
          {label}
        </label>
      )}
      {infoCopy && (
        <div data-test-id={testId(`${id}ToolTip`)} className={css.tooltipContainer}>
          <Tooltip
            tooltipId="toggleButtonTooltip"
            wrapperClassName={css.tooltipWrapper}
            contentTopClassName={css.tooltipContentTop}
            direction="top"
            content={infoCopy}
          >
            <MoreInfo width="14px" height="14px" />
          </Tooltip>
        </div>
      )}
      <button data-test-id={testId(id)} id="toggleBtn" className={css.toggleBtn} type="button" aria-pressed={isToggled} onClick={onToggle} />
    </div>
  );
};
export default ToggleButton;
